import React, { SVGProps } from 'react'
const SvgDarkChevronClosed = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#1B2C4F'}
      d="M3.646 6.313a.5.5 0 0 1 .651-.048l.057.048L8 9.96l3.647-3.647a.5.5 0 0 1 .65-.048l.057.048a.5.5 0 0 1 .048.651l-.048.056-4 4a.5.5 0 0 1-.651.049l-.056-.049-4-4a.5.5 0 0 1 0-.707Z"
    />
  </svg>
)
export default SvgDarkChevronClosed
